import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1872334c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1872334c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1872334c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1872334c')) {
      api.createRecord('1872334c', component.options)
    } else {
      api.reload('1872334c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1872334c&scoped=true", function () {
      api.rerender('1872334c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P5_Activitys/IncentiveForNew/index.vue"
export default component.exports